export default class BuildingQueue {
	static BUILD_QUEUE_SLOTS = 4;
	
	static TYPE_BUILD = 1; // в процессе строительства здания
	static TYPE_BUILD_QUEUE = 2; // очередь на строительство зданий
	static TYPE_DESTRUCTION = 3; // в процессе разбора руин
}